
















































































import { Component, Prop, Vue } from "vue-property-decorator";
import GiftCardModal from "@/views/gift-cards/partials/GiftCardModal.vue";
import { footerProps } from "@/helpers/footer-props";
import { formatDate } from "@/helpers/functions/format-date";
import { issuedHeaders } from "@/helpers/gift-cards/gift-card-table-headers";
import { truncateContent } from "@/helpers/functions/truncate-content";

@Component({
  name: "IssuedGiftCards",
  components: { GiftCardModal }
})
export default class IssuedGiftCards extends Vue {
  // ===== Props ===== //
  @Prop(Boolean) private readonly loading!: boolean;

  // ===== Store ===== //

  // ===== Data ===== //
  public footerProps = footerProps;
  public issuedHeaders = issuedHeaders;

  // ===== Methods ===== //
  public formatDate = formatDate;
  public truncateContent = truncateContent;
  public downloadIssuedCsv(): void {
    this.$store.dispatch("downloadIssuedGiftCardCsv");
  }

  // ===== Computed ===== //
  get issuedCards() {
    return this.$store.state.giftCards.issuedCards ? this.$store.state.giftCards.issuedCards : [];
  }
};
